module.exports = __webpack_public_path__ + "static/media/DK.43be0f63.svg";